<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Callcentre-Team",
  path: "team",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
